import { SEVERITY_OPTIONS } from 'src/apps/mfa/pages/sessions/sections/header/MfaSessionsFilterDefinitions';
import { TMfaSessionIssuesFilterOptions } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { orderByMethod } from 'src/common/helpers/DataFilterHelper';
import { formatFilterOptionsForEvSelect } from 'src/common/helpers/FormatHelper';

import { MfaSessionIssuesFilterOptionsQuery } from '../MfaSessionIssuesFilterOptions.generated';

export const transformMfaSessionIssuesFilterOptionsResults = (
	rawResults: MfaSessionIssuesFilterOptionsQuery
): TMfaSessionIssuesFilterOptions => {
	const {
		type_name_group_uniq_array: typeResults = [],
		scan_name_group_uniq_array: scanResults = []
	} = rawResults?.filter_groups?.[0] ?? {};

	return {
		severities: SEVERITY_OPTIONS,
		types: formatFilterOptionsForEvSelect(orderByMethod(typeResults.filter((type) => type))),
		scans: formatFilterOptionsForEvSelect(orderByMethod(scanResults.filter((scan) => scan)))
	};
};
